import { Services } from "../components/services";
import siteData from "../data/data.json";
import { Seo } from "../components/Seo";
import { BreadcrumbLd } from "../components/BreadcrumbLd";

export default function Servicios() {
  const servicesData = siteData["Services"] || {};
  return ( <>
  <Seo
  title="Servicios | Clases, pupilaje y eventos"
  description="Todos nuestros servicios: clases de equitación, estabulación, preparación de caballos, campamentos y eventos."
  path="/servicios"
  image="https://madridcampogrande.es/og/default.jpg"
/>
<BreadcrumbLd
  items={[
    { name: "Inicio", path: "/" },
    { name: "Servicios", path: "/servicios" },
  ]}
/>
    <Services data={servicesData} />
  </>);
}